<template>
  <!-- 底部 -->
  <div class="dibu">
    <div class="container">
      <div class="footer-content">
        <div class="logoleft">
          <!-- 左侧logo -->
          <div class="footer-logo">
            <img class="logo" src="@/assets/login_logo.png" alt="">
          </div>
          <div class="xian"></div>

          <!-- 中间信息 -->
          <div class="footer-info">
            <div class="company-name"><span style="color: #000;">单位名称: </span> 武汉东风鸿泰汽车资源循环利用有限公司</div>
            <!-- <div class="company-id"><span style="color: #000;">联系我们: </span>XXXXXXXXX</div> -->
            <!-- <div class="company-id"><span style="color: #000;">机构备案号: </span> 00000000000000000</div> -->
            <div class="address"><span style="color: #000;">单位地址: </span> 武汉市蔡甸区奓山街常福大街183号</div>
          </div>
        </div>

        <!-- 右侧二维码 -->
        <div style="color: transparent;" class="footer-qr">
          <div style="color: transparent;" class="qr-text">.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>



<style lang="scss" scoped>
// 变量定义
$container-width: 1200px;
$text-color: #666;
$bg-color: #f5f5f5;
$border-color: #f3f3f3;
$primary-color: #c31424;

.dibu {
  margin-top: 20px;
  background: #fff;
  padding: 20px 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
}

.container {
  width: $container-width;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer {
  &-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 120px;
  }

  &-logo {
    width: 200px;
  }

  &-info {
    flex: 1;
    padding: 0 10px;
  }

  &-qr {
    width: 80px;
    text-align: center;
  }
}

.logoleft {
  display: flex;
  align-items: center;
}

.xian {
  width: 1px;
  height: 100px;
  background-color: $border-color;
  margin-left: 10px;
}

.logo {
  width: 200px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.company {

  &-name,
  &-id,
  &-address {
    color: $text-color;
    margin-bottom: 8px;
    font-size: 14px;
  }
}

.links {
  margin: 10px 0;

  span {
    color: $text-color;
    margin-right: 20px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      color: $primary-color;
    }
  }
}

.box {
  width: 80px;
  height: 80px;
  background-color: #F6F6F6;
  margin-bottom: 20px;
}

.qr-text {
  color: $text-color;
  font-size: 14px;
}
</style>